'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.spinnerIconProps = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpinnerIcon = function SpinnerIcon(_ref) {
    var _ref$size = _ref.size,
        size = _ref$size === undefined ? 'lg' : _ref$size,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? 'primary' : _ref$color;
    return _react2.default.createElement('i', { className: 'far fa-circle-notch fa-spin fa-' + size + ' fa-fw ' + (color ? 'text-' + color : '') });
};

var spinnerIconProps = exports.spinnerIconProps = {
    size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
    color: _propTypes2.default.oneOf(['primary', 'secondary', 'warning', 'danger', 'info', 'white', 'light', 'dark'])
};

SpinnerIcon.propTypes = spinnerIconProps;

exports.default = SpinnerIcon;